<template>
  <div>
    <el-dialog :modal-append-to-body="false" :width="chooseParam.customWidth" :title="chooseParam.title" :visible.sync="dialogShow" :before-close="reset">
      <el-form inline-message :model="searchList">
        <el-row :gutter="0">
          <el-col :span="8" v-for="item in chooseParam.tableHeader" :key="item.id">
            <el-form-item v-if="item.isSearch=='yes'" :label="item.labelName" :prop="item.propName" :label-width="item.width">
              <el-input v-model="searchList[item.propName]" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6"> -->
          <div class="fl pb10">
            <el-button v-if="chooseParam.searchBtn" type="primary" @click="searchinfo" size="small" style="margin-left:10px;margin-top:2px">搜索</el-button>
            <el-button v-if="chooseParam.searchBtn" type="primary" @click="resetbtn" size="small" style="margin-top:2px">重置</el-button>
          </div>
          <!-- </el-col> -->
        </el-row>
      </el-form>
      <el-table ref="multipleTable" v-loading="loading" :data="list" :row-key="getRowKeys" border stripe highlight-current-row style="width: 100%;" @selection-change="handleSelData" :tree-props="{children: 'children'}">
        <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope"><span>{{scope.$index+(page.currentPage - 1) * page.pageSize + 1}} </span></template>
        </el-table-column>
        <el-table-column v-for="item in chooseParam.tableHeader" :key="item.id" :label="item.labelName" sortable>
          <template slot-scope="scope">
            <el-input-number v-if="item.type=='number'" v-model.number="scope.row[item.propName]" controls-position="right" :disabled="item.disabled" :min="0"></el-input-number>
            <el-input v-else-if="item.type=='input'" size="small" v-model="scope.row[item.propName]" :disabled="item.disabled"></el-input>
            <span v-else>{{scope.row[item.propName]}} </span>
          </template>
        </el-table-column>
      </el-table>
      <el-row class="pt10">
        <el-col :span="24">
          <!--判断显示-背景颜色代表含义 Begin-->
          <!-- <div class="pull-left"> -->
            <!-- <barArrowExplain></barArrowExplain> -->
          <!-- </div> -->
        </el-col>
      </el-row>
      <el-pagination background class="text-right pt10" @size-change="sizeChange" @current-change="currentChange" :current-page="page.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="page.pageSize" layout="total, sizes, prev, pager, next" :total="page.totalCount"></el-pagination>
      <div slot="footer">
        <el-button type="primary" @click="save">确 定</el-button>
        <el-button @click="reset">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// import barArrowExplain from '@/components/demandmanage/barArrowExplain'

export default {
  name: "dataChoose",
  components: {
    // barArrowExplain
  },
  data() {
    return {
      basic_url: Config.dev_url,
      list: [],
      //分页显示
      page: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0
      },
      selData: [],
      dialogShow: false,
      loading: false,
      chooseParam: {},
      searchList: {},
      method: "",
      selAray: []
    };
  },
  methods: {
    getRowKeys(row) {
      return row.id;
    },
    handleSelData(val, row) {
      console.log(val)
      this.selAray = val;
      // let selected = val.length && val.indexOf(row) !== -1;
      // console.log(selected)  // true就是选中，0或者false是取消选中
      // if (selected) {
      //   this.selAray.push(row)
      // } else {
      //   this.selAray.splice(this.selAray.indexOf(row), 1)
      // }
      // console.log(this.selAray)
    },
    sizeChange(val) {
      this.page.pageSize = val;
      this.searchList.page = this.page.currentPage;
      this.searchList.limit = this.page.pageSize;
      this.searchinfo();
    },
    currentChange(val) {
      this.page.currentPage = val;
      this.searchList.page = this.page.currentPage;
      this.searchList.limit = this.page.pageSize;
      this.searchinfo('search');
    },
    handleSelFile(val) {
      this.selFiles = val;
    },
    getListData(opt, parmData) {
      // this.resetbtn();
      this.chooseParam = parmData;
      this.dialogShow = true;
      this.loading = true;
      if (opt == "new") {
        var chooseParam = parmData;
      } else {
        var chooseParam = this.chooseParam;
      }
      var url = Config.dev_url + chooseParam.url;
      for (var i = 0; i < chooseParam.tableHeader.length; i++) {
        if (chooseParam.tableHeader[i].isSearch == "yes") {
          this.$set(this.searchList, chooseParam.tableHeader[i].propName, "");
        }
      }
      var data = {
        page: this.page.currentPage,
        limit: this.page.pageSize
      };
      this.searchList.page = this.page.currentPage
      this.searchList.limit = this.page.pageSize
      var searchParm = chooseParam.search;
      for (var i = 0; i < searchParm.length; i++) {
        data[searchParm[i].name] = searchParm[i].val;
      }
      var datatype = !!chooseParam.datatype ? chooseParam.datatype : "";
      this.method = !!chooseParam.method ? chooseParam.method : "post";
      if (this.method == 'get' || this.method == 'GET') {
        data = {
          params: data
        }
      }
      //兼容林post接口url上传参数
      if (!!chooseParam.isSpecialUrl) {
        url = url
          + '?page=' + this.page.currentPage
          + '&limit='
          + this.page.pageSize
        if (!!data.notin) {
          url = url + '&notin=' + data.notin;
          delete data.notin;
        }
        delete data.page;
        delete data.limit;
      }
      this.url = url;
      this.$axios[this.method](url, data)
        .then(res => {
          this.list = res.data.data || res.data.datas || res.data;
          this.page.totalCount = res.data.count;
          this.loading = false;
        })
        .catch(err => { });
    },
    reset() {
      this.$refs.multipleTable.clearSelection();//弹出框关闭清除选择痕迹
      this.dialogShow = false;
      this.list = [];
      this.page = {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0
      };
      this.selData = [];
      this.selAray = [];
    },
    resetbtn() {
      Object.keys(this.searchList).map((key, item) => {
        if (!(key == "page" || key == "limit")) this.searchList[key] = "";
      });
      this.page = {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0
      };
      this.searchList.page = 1;
      this.searchList.limit = 10;
      this.searchinfo();
    },
    searchinfo(val) {
      if (val != 'search') {
        this.searchList.page = 1;
        this.page.currentPage = 1;
      }
      var data = {
        params: this.searchList
      };
      this.$axios[this.method](this.url, data)
        .then(res => {
          this.list =
            res.data.data || res.data.subDicts || res.data.datas || res.data;
          this.loading = false;
          this.page.totalCount = res.data.count;
          for (var i = 0; i < this.list.length; i++) {
            for (var j = 0; j < this.selAray.length; j++) {
              if (this.getRowKeys(this.list[i]) == this.getRowKeys(this.selAray[j])) {
                this.$refs.multipleTable.toggleRowSelection(this.list[i], true);//必须传表格的数据；以数组[下标]格式传递
              }
            }
          }
        })
        .catch(err => { });
    },
    save() {
      if (this.selAray.length == 0) {
        this.$message({
          message: "请选择数据",
          type: "warning"
        });
      } else {
        console.log(this.selAray)
        this.$emit('tranFormData', this.selAray);
        //重置页面
        this.reset();
      }
    }
  }
};
</script>
